import { ControlValueAccessor } from '@angular/forms';

export abstract class ValueAccessorBase<T> implements ControlValueAccessor {
  protected innerValue: any;

  /**
   * Both onChange and onTouched are functions
   */
  onChange: any = () => { };
  onTouched: any = () => { };

  get value(): T {
    return this.innerValue;
  }

  set value(val: T) {
    this.setValue(val);
  }

  /**
   * We implement this method to keep a reference to the onChange
   * callback function passed by the forms API
   */
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  /**
   * We implement this method to keep a reference to the onTouched
   * callback function passed by the forms API
   */
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
  }

  /**
   * This is a basic setter that the forms API is going to use
   */
  writeValue(obj: T): void {
    this.value = obj;
  }

  protected setValue(val: T) {
    this.innerValue = val;
    this.onChange(val);
    this.onTouched();
  }
}
